module.exports = "<canvas class=\"chart chart-doughnut\"\r\n    width=\"100\"\r\n    height=\"100\"\r\n    chart-data=\"$ctrl.grafica.data\"\r\n    chart-colours=\"$ctrl.grafica.colours\"\r\n    chart-labels=\"$ctrl.grafica.labels\">\r\n</canvas>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/comisionistas/grafica/template.html
// module id = 1176
// module chunks = 0